export default [
    {
      reducerKey: 'statistics/filters',
      importReducer: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/store/reducer'),
    },
    {
      reducerKey: 'statistics',
      sagaKey: 'statisticsMainSaga',
      importReducer: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Main/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Main/store/saga'),
    },
    {
      reducerKey: 'statistics/account',
      sagaKey: 'statisticsAccountSaga',
      importReducer: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Account/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Account/store/saga'),
    },
    {
      reducerKey: 'statistics/campaign',
      sagaKey: 'statisticsCampaignSaga',
      importReducer: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Campaign/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Campaign/store/saga'),
    },
    {
      reducerKey: 'statistics/pulse',
      sagaKey: 'statisticsPulseSaga',
      importReducer: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Pulse/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-statistics" */ 'modules/Statistics/Pulse/store/saga'),
    },
]
